export class CycleLocalModel {

    /**
     * Staked tokens
     */
    staked_tokens: bigint = BigInt(0);

    /**
     * Claim timestamp
     */
    claim_timestamp: bigint = BigInt(0);

    /**
     * Fill values
     * 
     * @param values
     * @param app
     */
    fill(values: Array<any>) {
        this.staked_tokens = this.format(values, 'staked_tokens');
        this.claim_timestamp = this.format(values, 'claim_timestamp');
    }

    /**
     * Format value
     * 
     * @param values
     * @param key
     */
    private format(values: Array<any>, key: string): bigint {
        let value = values.find(x => x.key == 'cycle_' + key);
        if (value) {
            return BigInt(value.value);
        } else {
            return BigInt(0);
        }
    }
}